import axios from "axios";

const API = process.env.REACT_APP_API_URL;

// Phenological State
export const getPhenologicalStates = async (params) => {
	const { data } = await axios.get(`${API}/admin/phenological_state`, {
		params,
	});
	return data;
};

export const getPhenologicalState = async (params) => {
	const { data } = await axios.get(`${API}/admin/phenological_state/detail`, {
		params,
	});
	return data;
};

export const savePhenologicalState = async (params) => {
	const { data } = await axios.post(`${API}/admin/phenological_state/save`, params);
	return data;
};

export const deletePhenologicalState = async (params) => {
	const { data } = await axios.post(`${API}/admin/phenological_state/delete`, params);
	return data;
};

// Objectives
export const getObjectives = async (params) => {
	const { data } = await axios.get(`${API}/admin/objetives`, {
		params,
	});
	return data;
};

export const getObjective = async (params) => {
	const { data } = await axios.get(`${API}/admin/objetives/detail`, {
		params,
	});
	return data;
};

export const saveObjective = async (params) => {
	const { data } = await axios.post(`${API}/admin/objetives/save`, params);
	return data;
};

export const deleteObjective = async (params) => {
	const { data } = await axios.post(`${API}/admin/objetives/delete`, params);
	return data;
};

// Irrigations
export const getIrrigations = async (params) => {
	const { data } = await axios.get(`${API}/admin/irrigations`, {
		params,
	});
	return data;
};

export const getIrrigation = async (params) => {
	const { data } = await axios.get(`${API}/admin/irrigations/detail`, {
		params,
	});
	return data;
};

export const saveIrrigation = async (params) => {
	const { data } = await axios.post(`${API}/admin/irrigations/save`, params);
	return data;
};

export const deleteIrrigation = async (params) => {
	const { data } = await axios.post(`${API}/admin/irrigations/delete`, params);
	return data;
};
